import { Root, Image } from '@radix-ui/react-avatar';
import classnames from 'classnames';
import { CSSProperties } from 'react';
import { SHADOW_SM } from '../../Tokens/BoxShadow';
import type { AvatarPropsType } from './type';
import styles from './Avatar.module.css';

function Avatar({ className, style, size, src }: AvatarPropsType) {
  return (
    <Root
      className={classnames(styles.container, className)}
      style={{ width: size, height: size, '--avatar-shadow': SHADOW_SM } as CSSProperties}
    >
      <Image className={styles.image} src={src} alt="avatar_img" />
    </Root>
  );
}

export default Avatar;
